// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const ArticleModelRecord = require('client-v2/common/models/article/record')
const { keyedReviver, listReviver } = require('client-v2/common/state/record-reviver')
// Sibling imports
const CollectionListItemRecord = require('./records/collection-list-item')

class CollectionSelectModalRecord extends Immutable.Record({
  anchorId: null,
  article: null,
  articleState: FetchStateEnum.EMPTY,
  collections: Immutable.List(),
  collectionsState: FetchStateEnum.EMPTY,
  commentState: FetchStateEnum.EMPTY,
  commentText: String(),
  createState: FetchStateEnum.EMPTY,
  isUnmixPromptVisible: Boolean(),
  isVisible: Boolean(),
  filterText: String(),
  unmixState: FetchStateEnum.EMPTY,
  url: String()
}) {

  setArticle(articleObj) {
    if (!articleObj) {
      return this.delete('article')
    }
    return this.set('article', Immutable.fromJS(articleObj, articleReviver))
  }

  setCollections(collections) {
    if (!collections) {
      return this.delete('collections')
    }
    return this.set('collections', Immutable.fromJS(collections, collectionsReviver))
  }

  findCollectionIndex({ id, slug }) {
    if (slug) {
      return this.collections.findIndex(c => c.slug === slug)
    }
    if (id) {
      return this.collections.findIndex(c => c.id === id)
    }
    return -1
  }

  createCollection(collection) {
    const collectionIndex = this.findCollectionIndex(collection)
    return this.update('collections', collections => {
      if (collectionIndex === -1) {
        const collectionRecord = Immutable.fromJS(collection, collectionReviver)
        return collections.unshift(collectionRecord)
      }
      return collections.update(collectionIndex, c => {
        return c.mergeDeep(collection)
      })
    })
  }

  updateCollection(collection) {
    const collectionIndex = this.findCollectionIndex(collection)
    if (collectionIndex === -1) {
      return this
    }
    return this.update('collections', collections => {
      return collections.update(collectionIndex, c => {
        return c.mergeDeep(collection)
      })
    })
  }
}

const articleReviver = ArticleModelRecord.reviver
const collectionReviver = CollectionListItemRecord.reviver
const collectionsReviver = listReviver(collectionReviver)

CollectionSelectModalRecord.reviver = keyedReviver(CollectionSelectModalRecord, {
  article: articleReviver,
  collections: collectionsReviver
})

module.exports = CollectionSelectModalRecord
